import { addDays, subDays, subMonths, format, differenceInYears, parseISO } from 'date-fns';

const today = new Date();

export const mockUser = {
  id: 1,
  name: 'Jean-Marc Dupont',
  email: 'jm.dupont@garage-dupont.ch',
  company: 'Garage Dupont SA',
  plan: 'pro',
  avatar: null,
};

export const mockTenant = {
  id: 1,
  name: 'Garage Dupont SA',
  slug: 'garage-dupont',
  plan: 'pro',
  contacts_limit: 5000,
  emails_limit: 5000,
  ai_limit: 200,
  contacts_used: 847,
  emails_used: 1243,
  ai_used: 34,
};

const towns = ['Sion', 'Sierre', 'Martigny', 'Monthey', 'Nendaz', 'Verbier', 'Crans-Montana', 'Fully', 'Saxon', 'Visp'];
const categories = ['VIP', 'Fidèle', 'Régulier', 'Occasionnel', 'Inactif', 'Nouveau'];
const tones = ['auto', 'tutoiement', 'vouvoiement'];
const firstNames = ['Marie', 'Jean', 'Pierre', 'Sophie', 'Michel', 'Anne', 'Luc', 'Claire', 'François', 'Julie', 'Marc', 'Isabelle', 'Nicolas', 'Céline', 'Thomas', 'Nathalie', 'Laurent', 'Valérie', 'David', 'Christine'];
const lastNames = ['Dupont', 'Martin', 'Bernard', 'Petit', 'Robert', 'Richard', 'Durand', 'Leroy', 'Moreau', 'Simon', 'Laurent', 'Lefebvre', 'Michel', 'Garcia', 'David', 'Bertrand', 'Roux', 'Vincent', 'Fournier', 'Morel'];

function randomDate(start, end) {
  return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
}

function randomItem(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

function generateBirthDate(ageMin = 25, ageMax = 80) {
  const now = new Date();
  const birthYear = now.getFullYear() - Math.floor(Math.random() * (ageMax - ageMin) + ageMin);
  const birthMonth = Math.floor(Math.random() * 12) + 1;
  const birthDay = Math.floor(Math.random() * 28) + 1;
  return `${birthYear}-${String(birthMonth).padStart(2, '0')}-${String(birthDay).padStart(2, '0')}`;
}

function qualityScore(c) {
  let score = 0;
  if (c.first_name) score += 15;
  if (c.last_name) score += 15;
  if (c.email) score += 25;
  if (c.phone) score += 15;
  if (c.birth_date) score += 15;
  if (c.city) score += 10;
  if (c.relationship_memory) score += 5;
  return score;
}

// Generate contacts
let contactsData = Array.from({ length: 847 }, (_, i) => {
  const firstName = randomItem(firstNames);
  const lastName = randomItem(lastNames);
  const hasEmail = Math.random() > 0.12;
  const hasPhone = Math.random() > 0.35;
  const hasBirthDate = Math.random() > 0.28;
  const hasMemory = Math.random() > 0.75;
  const isActive = Math.random() > 0.22;

  // Make some birthdays near today for testing
  let birthDate = null;
  if (hasBirthDate) {
    if (i < 3) {
      // Today's birthdays
      const bYear = today.getFullYear() - (30 + i * 5);
      birthDate = `${bYear}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
    } else if (i < 8) {
      // This week
      const d = addDays(today, i - 2);
      const bYear = today.getFullYear() - (40 + i);
      birthDate = `${bYear}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    } else {
      birthDate = generateBirthDate();
    }
  }

  const lastInteraction = isActive
    ? format(randomDate(subMonths(today, 6), today), 'yyyy-MM-dd')
    : format(randomDate(subMonths(today, 24), subMonths(today, 7)), 'yyyy-MM-dd');

  const emailOpens = Math.floor(Math.random() * 15);
  const emailsSent = Math.floor(Math.random() * 20) + (emailOpens > 0 ? emailOpens : 0);
  const feedback = Math.random() > 0.7 ? Math.floor(Math.random() * 3) + 1 : 0;

  const engScore = Math.min(100, Math.round(
    (emailOpens / Math.max(emailsSent, 1)) * 60 +
    feedback * 10 +
    (isActive ? 20 : 0)
  ));

  const c = {
    id: i + 1,
    first_name: firstName,
    last_name: lastName,
    email: hasEmail ? `${firstName.toLowerCase()}.${lastName.toLowerCase()}${i > 0 ? i : ''}@example.ch` : null,
    phone: hasPhone ? `+41 79 ${Math.floor(100 + Math.random() * 900)} ${Math.floor(10 + Math.random() * 90)} ${Math.floor(10 + Math.random() * 90)}` : null,
    birth_date: birthDate,
    address: hasEmail ? `Rue ${randomItem(['de la Paix', 'du Centre', 'des Alpes', 'Principale', 'des Vignes'])} ${Math.floor(1 + Math.random() * 50)}` : null,
    postal_code: Math.floor(1900 + Math.random() * 300).toString(),
    city: randomItem(towns),
    canton: 'VS',
    category: randomItem(categories),
    tone: randomItem(tones),
    relationship_memory: hasMemory ? randomItem([
      'Préfère être contacté par e-mail, éviter les appels.',
      'Client depuis 2015, très fidèle. Sensible aux offres exclusives.',
      'A mentionné un projet de rénovation pour 2024.',
      'Tutoiement apprécié, très décontracté.',
      'Allergique aux newsletters trop fréquentes.',
      'Passionné de voitures de sport.',
    ]) : null,
    status: isActive ? 'active' : 'inactive',
    tags: [],
    last_interaction: lastInteraction,
    emails_sent: emailsSent,
    emails_opened: emailOpens,
    feedback_count: feedback,
    source: randomItem(['import', 'manuel', 'ERP']),
    created_at: format(randomDate(subMonths(today, 24), today), 'yyyy-MM-dd'),
    engagement_score: engScore,
  };
  c.quality_score = qualityScore(c);
  return c;
});

export const mockContacts = contactsData;

// Today's and upcoming birthdays
export const getTodaysBirthdays = () => {
  const m = today.getMonth() + 1;
  const d = today.getDate();
  return mockContacts.filter(c => {
    if (!c.birth_date) return false;
    const [, cm, cd] = c.birth_date.split('-');
    return parseInt(cm) === m && parseInt(cd) === d;
  });
};

export const getWeekBirthdays = () => {
  return mockContacts.filter(c => {
    if (!c.birth_date) return false;
    const [, cm, cd] = c.birth_date.split('-');
    for (let i = 1; i <= 7; i++) {
      const d = addDays(today, i);
      if (parseInt(cm) === d.getMonth() + 1 && parseInt(cd) === d.getDate()) return true;
    }
    return false;
  });
};

export const getMonthBirthdays = () => {
  const m = today.getMonth() + 1;
  return mockContacts.filter(c => {
    if (!c.birth_date) return false;
    const [, cm] = c.birth_date.split('-');
    return parseInt(cm) === m;
  });
};

export const getDormantContacts = () => {
  const threshold = subMonths(today, 12);
  return mockContacts.filter(c => {
    if (!c.last_interaction) return true;
    return parseISO(c.last_interaction) < threshold;
  });
};

export const getVIPContacts = () => {
  return mockContacts.filter(c => c.category === 'VIP' || c.engagement_score > 75);
};

export const mockCampaigns = [
  {
    id: 1, name: 'Anniversaires Mai 2025', type: 'birthday', status: 'sent',
    contacts: 12, opens: 9, clicks: 3, feedback: 4,
    sent_at: format(subDays(today, 5), 'yyyy-MM-dd'),
    open_rate: 75, objective: 'Fidéliser mes clients',
    notes: [
      { id: 1, date: format(subDays(today, 5), 'yyyy-MM-dd HH:mm'), text: 'Campagne envoyée sans problème. Bon taux d\'ouverture dès les premières heures.' },
      { id: 2, date: format(subDays(today, 3), 'yyyy-MM-dd HH:mm'), text: '3 clients ont répondu directement par e-mail pour remercier. Thomas Bertrand a pris RDV.' },
    ],
    report: null,
  },
  {
    id: 2, name: 'Réactivation clients dormants', type: 'reactivation', status: 'sent',
    contacts: 87, opens: 31, clicks: 8, feedback: 5,
    sent_at: format(subDays(today, 18), 'yyyy-MM-dd'),
    open_rate: 36, objective: 'Réactiver les clients dormants',
    notes: [
      { id: 1, date: format(subDays(today, 18), 'yyyy-MM-dd HH:mm'), text: 'Envoi effectué. Segment ciblé : inactifs depuis +6 mois.' },
      { id: 2, date: format(subDays(today, 15), 'yyyy-MM-dd HH:mm'), text: 'Taux ouverture plus faible que prévu. Certaines adresses outdatées à nettoyer.' },
      { id: 3, date: format(subDays(today, 10), 'yyyy-MM-dd HH:mm'), text: '2 RDV générés. Nathalie David et Marc Pont ont repris contact.' },
    ],
    report: null,
  },
  {
    id: 3, name: 'Offre révision printemps', type: 'promo', status: 'draft',
    contacts: 234, opens: 0, clicks: 0, feedback: 0,
    sent_at: null,
    open_rate: 0, objective: 'Lancer une offre ou une promotion',
    notes: [
      { id: 1, date: format(subDays(today, 2), 'yyyy-MM-dd HH:mm'), text: 'Brouillon en cours. Prévoir promo -15% révision complète pour segment Réguliers.' },
    ],
    report: null,
  },
  {
    id: 4, name: 'Fidélisation VIP', type: 'loyalty', status: 'scheduled',
    contacts: 45, opens: 0, clicks: 0, feedback: 0,
    sent_at: format(addDays(today, 3), 'yyyy-MM-dd'),
    open_rate: 0, objective: 'Fidéliser mes clients',
    notes: [],
    report: null,
  },
];

export const mockTemplates = [
  {
    id: 1, name: 'Joyeux anniversaire', type: 'birthday', tone: 'vouvoiement',
    subject: 'Joyeux anniversaire, {{prénom}} 🎉',
    body: `Cher(e) {{prénom}},

En ce jour spécial, toute l'équipe de {{entreprise}} vous adresse ses meilleurs vœux d'anniversaire.

Nous vous souhaitons une magnifique journée, entouré(e) de ceux qui vous sont chers.

Avec toute notre sympathie,
L'équipe {{entreprise}}`,
    variables: ['prénom', 'entreprise'],
  },
  {
    id: 2, name: 'Relance douce', type: 'reactivation', tone: 'vouvoiement',
    subject: 'Cela fait un moment, {{prénom}}…',
    body: `Bonjour {{prénom}},

Il y a quelque temps que nous ne nous sommes pas donné de nouvelles.

Nous espérons que tout va bien de votre côté.

Si vous avez des questions ou souhaitez nous rendre visite, nous serions ravis de vous revoir.

Cordialement,
L'équipe {{entreprise}}`,
    variables: ['prénom', 'entreprise'],
  },
  {
    id: 3, name: 'Offre promotionnelle', type: 'promo', tone: 'auto',
    subject: 'Une offre spéciale pour vous, {{prénom}}',
    body: `Bonjour {{prénom}},

Nous avons une offre exclusive réservée à nos clients fidèles comme vous.

[Décrivez votre offre ici]

N'hésitez pas à nous contacter pour en profiter.

Bien cordialement,
L'équipe {{entreprise}}`,
    variables: ['prénom', 'entreprise'],
  },
];

export const mockActions = [
  {
    id: 1,
    title: 'Envoyer les anniversaires du jour',
    reason: `3 clients fêtent leur anniversaire aujourd'hui. C'est le meilleur moment pour créer du lien.`,
    target: 'Contacts avec anniversaire aujourd\'hui',
    contacts: 3,
    impact: 'Élevé',
    effort: 'Faible',
    type: 'birthday',
    icon: '🎂',
    priority: 1,
    status: 'pending',
    link: '/birthdays',
  },
  {
    id: 2,
    title: 'Relancer 127 clients dormants',
    reason: '127 clients n\'ont eu aucune interaction depuis plus de 12 mois. Une relance douce peut en réactiver 20%.',
    target: 'Clients sans interaction depuis 12+ mois',
    contacts: 127,
    impact: 'Élevé',
    effort: 'Moyen',
    type: 'reactivation',
    icon: '💤',
    priority: 2,
    status: 'pending',
    link: '/campaigns',
  },
  {
    id: 3,
    title: 'Compléter 94 fiches sans e-mail',
    reason: '94 contacts n\'ont pas d\'adresse e-mail. Enrichir la base augmente votre portée de 11%.',
    target: 'Contacts sans e-mail',
    contacts: 94,
    impact: 'Moyen',
    effort: 'Moyen',
    type: 'enrich',
    icon: '📋',
    priority: 3,
    status: 'pending',
    link: '/contacts?noEmail=1',
  },
  {
    id: 4,
    title: 'Remercier vos 18 clients VIP',
    reason: '18 clients ont un score d\'engagement > 80. Un message de remerciement renforce leur fidélité.',
    target: 'Clients VIP (engagement > 80)',
    contacts: 18,
    impact: 'Élevé',
    effort: 'Faible',
    type: 'loyalty',
    icon: '⭐',
    priority: 4,
    status: 'pending',
    link: '/templates',
  },
  {
    id: 5,
    title: 'Booster vos avis Google',
    reason: '73% des consommateurs lisent les avis avant de choisir. Demandez à vos 18 VIP de laisser un avis — cela booste votre référencement local.',
    target: 'Clients satisfaits & VIP',
    contacts: 18,
    impact: 'Élevé',
    effort: 'Faible',
    type: 'reviews',
    icon: '⭐',
    priority: 5,
    status: 'pending',
    link: '/templates',
  },
  {
    id: 6,
    title: 'Lancer un programme de parrainage',
    reason: 'Un client satisfait peut en amener 3 autres. Un programme simple (réduction / cadeau) décuple votre acquisition sans budget pub.',
    target: 'Clients actifs fidèles',
    contacts: 52,
    impact: 'Élevé',
    effort: 'Moyen',
    type: 'referral',
    icon: '🤝',
    priority: 6,
    status: 'pending',
    link: '/campaigns',
  },
  {
    id: 7,
    title: 'Publier 3 posts Instagram cette semaine',
    reason: 'Votre dernier post date de 18 jours. La régularité sur Instagram booste l\'algorithme — visez 3x/semaine pour maintenir la visibilité.',
    target: 'Audience Instagram',
    contacts: 340,
    impact: 'Moyen',
    effort: 'Faible',
    type: 'social',
    icon: '📸',
    priority: 7,
    status: 'pending',
    link: '/strategy?plan=comms',
  },
];

export const mockSmtp = {
  configured: false,
  host: '',
  port: 587,
  username: '',
  encryption: 'tls',
  from_email: '',
  from_name: '',
  verified: false,
};

export const mockAnalytics = {
  crm_health: 72,
  email_rate: 88,
  birthdate_rate: 72,
  phone_rate: 65,
  address_rate: 78,
  duplicate_rate: 2,
  active_rate: 78,
  total_contacts: 847,
  active_contacts: 660,
  dormant_contacts: 127,
  vip_contacts: 34,
  avg_engagement: 45,
  emails_sent_month: 312,
  emails_opened_month: 187,
  open_rate_month: 60,
  feedback_month: 23,
  age_distribution: [
    { range: '18-25', count: 38 },
    { range: '26-35', count: 124 },
    { range: '36-45', count: 189 },
    { range: '46-55', count: 213 },
    { range: '56-65', count: 168 },
    { range: '66+', count: 115 },
  ],
  geo_distribution: [
    { city: 'Sion', count: 187 },
    { city: 'Sierre', count: 134 },
    { city: 'Martigny', count: 98 },
    { city: 'Monthey', count: 76 },
    { city: 'Nendaz', count: 54 },
    { city: 'Autres', count: 298 },
  ],
  category_distribution: [
    { name: 'VIP', count: 34 },
    { name: 'Fidèle', count: 187 },
    { name: 'Régulier', count: 243 },
    { name: 'Occasionnel', count: 198 },
    { name: 'Inactif', count: 185 },
  ],
  monthly_emails: [
    { month: 'Jan', sent: 234, opened: 145 },
    { month: 'Fév', sent: 312, opened: 198 },
    { month: 'Mar', sent: 287, opened: 172 },
    { month: 'Avr', sent: 445, opened: 289 },
    { month: 'Mai', sent: 312, opened: 187 },
  ],
};

export const mockReminders = [];

export const objectives = [
  { id: 'fidelize', icon: '💛', title: 'Fidéliser mes clients', description: 'Anniversaires, attentions, messages personnalisés', color: '#FFC400' },
  { id: 'reactivate', icon: '💤', title: 'Réactiver les clients dormants', description: 'Contacts sans interaction depuis 6, 12 ou 24 mois', color: '#7B61FF' },
  { id: 'revenue', icon: '📈', title: 'Augmenter mon chiffre d\'affaires', description: 'Segments à potentiel, zones fortes, opportunités', color: '#10B981' },
  { id: 'appointments', icon: '📅', title: 'Générer plus de rendez-vous', description: 'Contacts prioritaires, messages de prise de contact', color: '#5A35FF' },
  { id: 'enrich', icon: '🗂️', title: 'Améliorer ma base client', description: 'E-mails manquants, doublons, données incomplètes', color: '#F59E0B' },
  { id: 'know', icon: '🔍', title: 'Mieux connaître ma clientèle', description: 'Âges, villes, typologies, segments dominants', color: '#06B6D4' },
  { id: 'birthday', icon: '🎂', title: 'Créer une campagne anniversaire', description: 'Anniversaires du mois, âges ronds, messages', color: '#FF4FA3' },
  { id: 'vip', icon: '⭐', title: 'Détecter mes meilleurs clients', description: 'VIP, fidèles, engagés, clients anciens', color: '#F59E0B' },
  { id: 'local', icon: '📍', title: 'Créer une campagne locale', description: 'Communes, cantons, régions ciblées', color: '#10B981' },
  { id: 'promo', icon: '🎯', title: 'Lancer une offre ou une promotion', description: 'Cible, message, ton, planning, indicateurs', color: '#EF4444' },
];
